import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import { Layout, Container, PageTitle } from 'src/components/Layout'
import List from 'src/components/List'

import intlMessages from './translations'
import AddVehicleIcon from './AddVehicle/AddVehicleIcon'
import RemoveVehicleIcon from './RemoveVehicle/RemoveVehicleIcon'

class Passenger extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  getListItems = () => {
    return [
      {
        leftIcon: ['far', 'user-plus'],
        name: this.props.intl.formatMessage(intlMessages.documentLinkAddDriver),
        type: 'AddPerson',
        url: '/changepolicy/vehicle/driver/add',
        rightIcon: 'right',
        hideArrow: true,
      },
      {
        leftIcon: ['far', 'user-minus'],
        name: this.props.intl.formatMessage(intlMessages.documentLinkRemoveDriver),
        type: 'RemovePerson',
        url: '/changepolicy/vehicle/driver/remove',
        rightIcon: 'right',
        hideArrow: true,
      },
      {
        leftIcon: <AddVehicleIcon />,
        leftIconType: 'component',
        name: this.props.intl.formatMessage(intlMessages.documentLinkAddVehicle),
        type: 'AddVehicle',
        url: '/changepolicy/vehicle/add',
        rightIcon: 'right',
        hideArrow: true,
      },
      {
        leftIcon: <RemoveVehicleIcon />,
        leftIconType: 'component',
        name: this.props.intl.formatMessage(intlMessages.documentLinkRemoveVehicle),
        type: 'RemoveVehicle',
        url: '/changepolicy/vehicle/remove',
        rightIcon: 'right',
        hideArrow: true,
      },
      {
        leftIcon: 'Other',
        name: this.props.intl.formatMessage(intlMessages.documentLinkOther),
        type: 'Other',
        url: '/changepolicy/other',
        rightIcon: 'right',
        hideArrow: true,
      },
    ]
  }

  handleClick = item => {
    if (item.type === 'noPassenger') {
      this.props.setPassenger(null)
    }
  }

  render() {
    return (
      <Layout>
        <PageTitle title={this.props.intl.formatMessage(intlMessages.policyTypeVehicle)} showBack />
        <Container>
          <List
            isOverflown={true}
            items={this.getListItems()}
            onClick={this.handleClick}
            isPoliciesList={true}
            styleVariationDesktop='blocks'
          />
        </Container>
      </Layout>
    )
  }
}

export default injectIntl(Passenger)
